import { Component } from 'react';
import { findSortOrder, smartSort } from './utils';
import { DEFAULT_PER_PAGE } from './consts';
import {
  PaginationControllerProps,
  PaginationControllerState,
  SortBy,
  SortById,
} from './types';
import { SortOrder } from '@ardoq/api-types';

export class PaginationController<TData> extends Component<
  PaginationControllerProps<TData>,
  PaginationControllerState
> {
  constructor(props: PaginationControllerProps<TData>) {
    super(props);
    const sortOrder = props.defaultSortOrder || SortOrder.DEFAULT;
    const sortById = props.defaultSortById || null;
    this.state = {
      currentPageNumber: props.startPageNumber || 1,
      sortOrder,
      sortById,
    };
  }
  setPage = (currentPageNumber: number) => {
    this.setState({ currentPageNumber });
    this.notifyPageNumberChange(currentPageNumber);
  };

  handleSortBy = (sortBy: SortBy<TData>, sortById?: SortById) => {
    const [sortOrder, newSortById] = findSortOrder(
      this.state,
      sortBy,
      sortById
    );

    this.setState({
      currentPageNumber: 1,
      sortById: newSortById,
      sortOrder,
    });
    this.notifyPageNumberChange(1);
  };

  getSortedDataSource(sortOrder: SortOrder, sortBy?: SortBy<TData>) {
    return smartSort(this.props.dataSource, sortBy, sortOrder, {
      sortNumbersAfterStrings: this.props.sortNumbersAfterStrings,
    });
  }

  notifyPageNumberChange(pageNumber: number) {
    this.props.onPageNumberChange?.(pageNumber);
  }

  componentDidUpdate({ dataSource }: PaginationControllerProps<TData>) {
    const hasLengthChanged = dataSource.length !== this.props.dataSource.length;
    if (hasLengthChanged) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ currentPageNumber: 1 });
      this.notifyPageNumberChange(1);
    }
  }

  render() {
    const currentPageNumber = this.state.currentPageNumber;
    const perPage = this.props.perPage || DEFAULT_PER_PAGE;
    const totalResults = this.props.dataSource.length;
    const from = (currentPageNumber - 1) * perPage;
    const to = currentPageNumber * perPage;
    const dataSource = this.getSortedDataSource(
      this.state.sortOrder,
      this.state.sortById || undefined
    );
    const currentPageDataSource = dataSource.slice(from, to);

    return this.props.render({
      currentPageNumber,
      perPage,
      totalResults,
      currentPageDataSource,
      onPageSelect: this.setPage,
      sortBy: this.handleSortBy,
      sortById: this.state.sortById,
      sortOrder: this.state.sortOrder,
    });
  }
}
